import {Component, Input, OnInit} from '@angular/core';
import {DecimalPipe} from '@angular/common';

@Component({
  selector: 'app-mobile-table-item',
  templateUrl: './mobile-table-item.component.html',
  styleUrls: []
})
export class MobileTableItemComponent implements OnInit {

  @Input() text = '';
  @Input() value = '';

  @Input() isDate = false;

  isNumber = false;

  constructor(private readonly decimalPipe: DecimalPipe) { }

  ngOnInit() {
    if (!isNaN(+this.value) && !this.isDate) {
      this.isNumber = true;
      this.value = this.decimalPipe.transform(this.value, '0.0-2', 'se');
    }
  }
}
